import PropTypes from 'prop-types';
import React from 'react';

import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { MdDelete, MdDownload, MdEdit, MdSource } from 'react-icons/md';

import { downloadZipFolder } from '../../../../../../services/auxiliaryFunctions/functions';
import {
  ButtonsActionsStyled,
  CellBodyStyled,
  CellHeaderStyled,
} from './TableFolder.styles';

export function TableFolder(props) {
  const {
    data,
    keys,
    headings,
    editActions,
    foldersShow,
    buttonEditFunction,
    buttonDeleteFunction,
    callbackClickRow = () => {},
  } = props;
  return (
    <TableContainer style={{ marginTop: 16 }} id="folder-table">
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {headings.map((heading) => (
              <CellHeaderStyled key={heading}>{heading}</CellHeaderStyled>
            ))}
            {editActions && (
              <CellHeaderStyled key="action">Ações</CellHeaderStyled>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={row.id}>
              <TableCell>
                <MdSource size={20} />
              </TableCell>
              {keys.map((cell) => (
                <CellBodyStyled
                  key={cell}
                  onClick={() => callbackClickRow(data[index])}
                >
                  {row[cell]}
                </CellBodyStyled>
              ))}
              {editActions && (
                <ButtonsActionsStyled>
                  {buttonEditFunction && (
                    <IconButton
                      className="buttonEdit"
                      onClick={() => buttonEditFunction(row.id)}
                      size="large"
                    >
                      <MdEdit size={24} />
                    </IconButton>
                  )}
                  {foldersShow && (
                    <IconButton
                      className="buttonEdit"
                      onClick={() => downloadZipFolder(row)}
                      size="large"
                    >
                      <MdDownload size={24} />
                    </IconButton>
                  )}
                  {buttonDeleteFunction && (
                    <>
                      {!buttonEditFunction && (
                        <IconButton
                          className="buttonEdit"
                          onClick={() => callbackClickRow(data[index])}
                          size="large"
                        >
                          <MdDownload size={24} />
                        </IconButton>
                      )}
                      <IconButton
                        className="buttonDelete"
                        onClick={() => buttonDeleteFunction(row.id)}
                        size="large"
                      >
                        <MdDelete size={24} />
                      </IconButton>
                    </>
                  )}
                </ButtonsActionsStyled>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

TableFolder.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      construction_id: PropTypes.number,
      id: PropTypes.number,
      kind: PropTypes.string,
      last_modified: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  headings: PropTypes.arrayOf(PropTypes.string).isRequired,
  foldersShow: PropTypes.bool.isRequired,
  buttonEditFunction: PropTypes.func,
  buttonDeleteFunction: PropTypes.func,
  callbackClickRow: PropTypes.func,
  editActions: PropTypes.bool,
};

TableFolder.defaultProps = {
  buttonEditFunction: () => {},
  buttonDeleteFunction: () => {},
  callbackClickRow: () => {},
  editActions: false,
};
